export default {
  avatar: {
    title: "Đổi ảnh đại diện",
  },
  bindRole: {
    allServers: "Toàn bộ máy chủ",
    bindFailed: "Liên kết nhân vật thất bại",
    bindSuccess: "Liên kết nhân vật thành công",
    getRoleListFailed: "Lấy danh sách nhân vật thất bại",
    getServerListFailed: "Lấy danh sách server thất bại",
    modifyTitle: "Đổi liên kết nhân vật",
    noRole: "Chưa có nhân vật",
    recentServers: "Máy chủ của bạn",
    role: "Tên nhân vật:",
    rolePlaceholder: "Chọn nhân vật",
    server: "Server:",
    serverPlaceholder: "Chọn server",
    title: "Liên kết nhân vật",
  },
  commentModal: {
    placeholder: "Viết bình luận...",
    replyTo: "Trả lời {username}",
    title: "Bình luận",
  },
  common: {
    cancel: "Hủy",
    confirm: "Xác nhận",
    landscapeTip: "Vui lòng xoay điện thoại của bạn sang chế độ dọc để có trải nghiệm tốt hơn",
    loadMore: "Kéo lên để tải thêm",
    loading: "Đang tải...",
    loadingMore: "Tải thêm...",
    noMore: "Không còn dữ liệu nào nữa",
    refreshFailed: "Làm mới thất bại",
    refreshSuccess: "Làm mới thành công",
    submit: "Gửi",
    all: "Tất cả",
    language: "Ngôn ngữ",
  },
  error: {
    50002: "Token không hợp lệ hoặc đã hết hạn",
    50006: "Biệt danh này đã được người khác sử dụng",
    50007: "Bạn chỉ có thể thay đổi biệt danh một lần mỗi tháng, bạn đã thay đổi trong tháng này",
    50008: "Không đủ điểm",
    50301: "Bạn không có quyền đăng bài",
    50302: "Số lần đăng bài đã đạt giới hạn",
    50303: "Độ dài nội dung không đáp ứng yêu cầu",
    50304: "Nội dung chứa từ không hợp lệ, vui lòng chỉnh sửa rồi thử lại",
    50308: "Bạn không có quyền xem bài viết này",
    50309: "Bài viết đã bị xóa hoặc di chuyển",
    50351: "Chủ đề đã bị đóng, không thể trả lời",
    50353: "Bạn không có quyền trả lời",
    50354: "Khu vực này cấm trả lời",
    50355: "Đăng bài quá nhiều lần, vui lòng thử lại sau",
    50356: "Số lượng đăng bài mỗi giờ đã đạt giới hạn",
    50361: "Bình luận không tồn tại",
    50500: "Bạn không có quyền tìm kiếm",
    50501: "Chức năng tìm kiếm đã bị tắt",
    50502: "Nội dung chứa từ không hợp lệ, vui lòng chỉnh sửa rồi thử lại",
    50505: "Tìm kiếm quá thường xuyên, vui lòng thử lại sau",
    50703: "Hình ảnh không được duyệt",
    50704: "Nội dung hình ảnh không phù hợp",
    50214: "Chia sẻ thất bại: bạn chưa gia nhập @:shareModal.alliance.",
    common: "Thao tác thất bại, vui lòng thử lại sau",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Đã điểm danh",
    loginInSuccess: "Đăng nhập thành công",
    pleaseLogin: "Hãy đăng nhập trước",
    loginNow: "Đăng nhập",
    pullToRefresh: "Kéo xuống để làm mới",
    releaseToRefresh: "Thả ra để làm mới",
    signFailed: "Điểm danh thất bại",
    signIn: "Điểm danh",
    signInFailedTip: "Điểm danh thất bại, vui lòng thử lại sau",
    signSuccess: "Điểm danh thành công",
    goToShop: "Đến Trung Tâm Điểm",
    sortByLastPost: "Bình luận gần đây",
    sortByTime: "Mới nhất",
    tags: {
      activity: "Hoạt động",
      chats: "Giao lưu",
      guide: "Hướng dẫn",
      recommend: "Đề xuất",
      news: "Tin tức",
    },
    unboundRole: "Chưa liên kết nhân vật",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "Đang bảo trì",
    message: "Xin lỗi, diễn đàn trò chơi hiện đang được bảo trì. Vui lòng thử lại sau.",
  },
  mentionModal: {
    searchPlaceholder: "Tìm kiếm người dùng",
    title: "Chọn người dùng",
  },
  nicknameModify: {
    alreadyRenamed:
      "Mỗi tháng chỉ được đổi biệt danh 1 lần, tháng này bạn đã đổi rồi",
    changedNickname: "Đổi biệt danh",
    cost: "Tiêu hao",
    date: "Ngày",
    getMore: "Nhận",
    nicknameTooShort: "Biệt danh không được ít hơn 3 chữ",
    coinNotEnough: "Không đủ điểm",
    placeholder: "Vui lòng nhập biệt danh",
    recordTitle: "Lịch sử đổi",
    sameNickname: "Biệt danh không được trùng với biệt danh hiện tại",
    success: "Đổi thành công",
    viewRecord: "Xem lịch sử đổi",
  },
  notice: {
    empty: "Chưa có tin nhắn nào",
    likeComment: "{username} đã thích bình luận của bạn",
    likePost: "{username} đã thích bài viết của bạn",
    mentionComment: "{username} đã nhắc đến bạn trong bình luận",
    mentionPost: "{username} đã nhắc đến bạn trong bài viết",
    replyComment: "{username} đã trả lời bình luận của bạn",
    replyPost: "{username} đã trả lời bài viết của bạn",
    system: "Thông báo hệ thống",
    tabs: {
      like: "Thích",
      mention: "Nhắc đến tôi",
      notification: "Thông báo",
      reply: "Trả lời tôi",
    },
    title: "Thông báo tin nhắn",
  },
  operateModal: {
    confirmDelete: "Bạn có chắc muốn xóa bài viết này không?",
    copyFailed: "Sao chép thất bại",
    copyLink: "Sao chép liên kết",
    copySuccess: "Sao chép thành công",
    delete: "Xóa",
    shareToGame: "Chia sẻ vào game",
    deleteFailed: "Xóa thất bại",
    deleteSuccess: "Xóa thành công",
    title: "Thao tác",
  },
  shareModal: {
    selectChannelTitle: "Vui lòng chọn kênh chia sẻ đến",
    channelLabel: "Kênh",
    channelPlaceholder: "Chọn kênh",
    alliance: "Liên Minh",
    shareSuccess: "Chia sẻ thành công",
    continueBrowse: "Tiếp tục xem",
    goToGame: "Vào game xem",
    noThreadTip: "Vui lòng mở bài viết trước",
  },
  post: {
    create: {
      contentEmpty: "Nội dung không được để trống",
      contentPlaceholder: "Lúc này bạn muốn nói gì...",
      failed: "Đăng thất bại",
      fileTooLarge: "Kích thước tệp vượt quá giới hạn（最大 {maxSize}）",
      image: "Hình ảnh",
      imageSizeLimit: "Kích thước hình ảnh không được vượt quá 5MB",
      imageUploadFailed: "Tải ảnh lên thất bại",
      imageUploadSuccess: "Tải ảnh lên thành công",
      imageUploading: "Đang tải ảnh lên, vui lòng chờ...",
      invalidFileType: "Loại tệp không được hỗ trợ",
      maxCharsReached: "Đã đạt giới hạn số ký tự tối đa ({max} ký tự)",
      mention: "{'@'}",
      selectBoard: "Chọn chuyên mục",
      topicLabel: "Chủ đề",
      submit: "Đăng",
      submitting: "Đang đăng...",
      success: "Đăng thành công",
      title: "Đăng bài",
      titleEmpty: "Tiêu đề không được để trống",
      titlePlaceholder: "Vui lòng nhập tiêu đề",
      video: "Video",
      videoSizeLimit: "Kích thước video không được vượt quá 50MB",
      videoUploadFailed: "Tải video lên thất bại",
      videoUploadSuccess: "Tải video lên thành công",
      videoUploading: "Đang tải video lên, vui lòng chờ...",
    },
    title: "Bài viết",
  },
  postDetail: {
    allComments: "Tất cả {num} tin trả lời",
    allReplies: "Tất cả trả lời",
    author: "Tác giả",
    cancelFavorite: "Đã hủy lưu",
    commentTooShort: "Nội dung bình luận không ít hơn 5 chữ",
    translate: "Dịch",
    translating: "Đang dịch...",
    translateSuccess: "Dịch thành công",
    translateFailed: "Dịch thất bại",
    translatedTo: "Đã dịch sang",
    earliest: "Trả lời sớm nhất",
    favoriteSuccess: "Đã lưu thành công",
    floor: "Tầng",
    latest: "Trả lời mới nhất",
    loadFailed: "Tải thất bại",
    noContent: "Chưa có nội dung",
    onlyAuthor: "Chỉ xem tác giả",
    reply: "Trả lời",
    replyTo: "Trả lời",
    sendFailed: "Gửi thất bại",
    sendSuccess: "Gửi thành công",
    sending: "Đang gửi...",
    viewOriginalPost: "Xem bài gốc",
    writeSomething: "Nói gì đó...",
  },
  profile: {
    addLikeSuccess: "Thích thành công",
    cancelLikeSuccess: "Hủy thích thành công",
    communityId: "ID Cộng Đồng",
    editNickname: "Đổi biệt danh",
    followSuccess: "Theo dõi thành công",
    followed: "Đã theo dõi",
    followers: "Người theo dõi",
    follow: "Theo dõi",
    likes: "Lượt thích",
    noFavorites: "Chưa có mục yêu thích",
    noPosts: "Chưa có động thái",
    shopLabel: "Cửa hàng điểm",
    tabs: {
      favorites: "Mục yêu thích",
      posts: "Động thái của tôi",
    },
    title: "Trung tâm cá nhân",
    unfollowSuccess: "Hủy theo dõi thành công",
  },
  search: {
    btn: "Tìm kiếm",
    empty: "Không có nội dung liên quan",
    filter: {
      dateline: "Mới nhất",
      title: "Sắp xếp",
      views: "Nổi bật",
    },
    historyTitle: "Lịch sử tìm kiếm",
    hotTitle: "Tìm kiếm hot",
    relatedPosts: "Bài viết liên quan",
    tabs: {
      post: "Bài viết",
      user: "Người dùng",
    },
  },
  setting: {
    about: "Về chúng tôi",
    logout: "Đăng xuất",
    logoutSuccess: "Đã đăng xuất",
    privacy: "Chính sách bảo mật",
    service: "Điều khoản dịch vụ",
    title: "Cài đặt",
  },
  shop: {
    emptyTip: "Cửa hàng đang xây dựng, vui lòng chờ~",
    record: "Lịch sử đổi thưởng",
    title: "Trung Tâm Đổi",
    bindRole: "Liên kết nhân vật",
    switchRole: "Đổi nhân vật",
    tabs: {
      tasks: "Nhiệm vụ điểm",
      rewards: "Đổi thưởng",
    },
    taskInProgress: "Đang thực hiện",
    taskCompleted: "Hoàn thành",
    goToComplete: "Hoàn thành",
    exchange: "Đổi",
    exchanged: "Đã đổi",
    exchangeConfirmTitle: "Xác nhận đổi thưởng?",
    currentCoins: "Điểm hiện tại",
    costCoins: "Điểm tiêu hao",
    receiveRole: "Nhân vật nhận thưởng",
    exchangeSuccess: "Đổi thưởng thành công",
    exchangeFailed: "Đổi thưởng thất bại",
  },
  exchangeRecord: {
    time: "Thời gian",
    content: "Nội dung",
    points: "Điểm",
    empty: "Không có lịch sử đổi thưởng",
  },
  tabBar: {
    home: "Trang chủ",
    notice: "Tin nhắn",
    profile: "Của tôi",
  },
  time: {
    hoursAgo: "{hours} giờ trước",
    minutesAgo: "{minutes} phút trước",
  },
};
